// EDIT BY ALI FOR DARK MODE - Updated to use ThemeProvider and dynamic theme
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import {CssBaseline, ThemeProvider as MuiThemeProvider} from "@mui/material";
import {createAlphaSearchTheme} from "./theme";
import {applyThemeCssVariables} from "./theme/colorTokens";
import AuthProvider from "./components/AuthProvider";
import ThemeProvider, {useThemeMode} from "./components/ThemeProvider";
import {APIProvider} from "@vis.gl/react-google-maps";
import RuntimeConfigProvider, {useRuntimeConfig} from "./config/RuntimeConfigProvider";
import AnalyticsConsent from "./components/AnalyticsConsent";

// EDIT BY ALI FOR DARK MODE - Component to wrap app with theme based on dark mode
const ThemedApp = () => {
  const config = useRuntimeConfig();
  const { darkMode } = useThemeMode();
  const theme = React.useMemo(() => createAlphaSearchTheme(darkMode ? "dark" : "light"), [darkMode]);
  
  // EDIT BY ALI FOR DARK MODE - Set data-theme + CSS primary tokens for mode
  React.useEffect(() => {
    document.body.setAttribute("data-theme", darkMode ? "dark" : "light");
    applyThemeCssVariables(darkMode);
  }, [darkMode]);
  
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline>
        <AnalyticsConsent>
        <AuthProvider>
          <APIProvider
            apiKey={config.PUBLIC_GOOGLE_MAPS_JAVASCRIPT_API_KEY}
            onLoad={() => console.log('Maps API has loaded.')}>
              <App />
          </APIProvider>
        </AuthProvider>
        </AnalyticsConsent>
      </CssBaseline>
    </MuiThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RuntimeConfigProvider>
      <BrowserRouter>
      <ThemeProvider>
        <ThemedApp />
      </ThemeProvider>
      </BrowserRouter>
    </RuntimeConfigProvider>
  </React.StrictMode>
)
